
import { Component, Prop, Vue } from 'vue-property-decorator'
import ImageBase from '@/components/atoms/ImageBase.vue'
import TitlePage from '@/components/atoms/TitlePage.vue'
import TextFrame from '@/components/atoms/TextFrame.vue'
import LinkBase from '@/components/atoms/LinkBase.vue'
import PanelFrame from '@/components/molecules/PanelFrame.vue'

/**
 * パスワード再設定関連の案内テキスト表示ページ
 */
@Component({
  components: {
    ImageBase,
    TitlePage,
    TextFrame,
    LinkBase,
    PanelFrame,
  },
})
export default class PasswordGuide extends Vue {
  /** 遷移先ページへのリンクURL */
  @Prop()
  private linkUrl?: string
}
